export default "__VITE_ASSET__7eieReNK__"